import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { updateUserBirthday, getUserBirthday } from '../services/profileService';
import './BirthdayModal.css';

const BirthdayModal = ({ isOpen, onClose, onBirthdayUpdate }) => {
  const { currentUser } = useAuth();
  const [birthday, setBirthday] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadCurrentBirthday = useCallback(async () => {
    if (!currentUser) return;
    
    try {
      setLoading(true);
      const currentBirthday = await getUserBirthday(currentUser.uid);
      if (currentBirthday) {
        // Convert from YYYY-MM-DD to input format
        setBirthday(currentBirthday);
      } else {
        setBirthday('');
      }
    } catch (err) {
      console.error('Error loading birthday:', err);
    } finally {
      setLoading(false);
    }
  }, [currentUser]);

  useEffect(() => {
    if (isOpen) {
      loadCurrentBirthday();
    }
  }, [isOpen, loadCurrentBirthday]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!currentUser) {
      setError('User not authenticated');
      return;
    }
    
    if (!birthday) {
      setError('Please select a birthday');
      return;
    }

    try {
      setLoading(true);
      setError(null);
      
      await updateUserBirthday(currentUser.uid, birthday);
      onBirthdayUpdate?.(birthday);
      onClose();
    } catch (err) {
      console.error('Error updating birthday:', err);
      setError('Failed to update birthday. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setBirthday('');
    setError(null);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="birthday-modal-overlay">
      <div className="birthday-modal">
        <div className="birthday-modal-header">
          <h2>Set Birthday</h2>
          <button 
            className="birthday-modal-close"
            onClick={handleClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="birthday-modal-form">
          <div className="birthday-modal-field">
            <label htmlFor="birthday">Birthday:</label>
            <input
              id="birthday"
              type="date"
              value={birthday}
              onChange={(e) => setBirthday(e.target.value)}
              max={new Date().toISOString().split('T')[0]} // Can't be in the future
              disabled={loading}
              required
            />
          </div>
          
          {error && (
            <div className="birthday-modal-error">
              {error}
            </div>
          )}
          
          <div className="birthday-modal-actions">
            <button 
              type="button" 
              onClick={handleClose}
              className="birthday-modal-cancel"
              disabled={loading}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="birthday-modal-save"
              disabled={loading || !birthday}
            >
              {loading ? 'Saving...' : 'Save Birthday'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BirthdayModal;
